import sanityImageURL from "@sanity/image-url";
import { appConfig } from "../appConfig";

// Standalone image URL builder so client components (e.g. SanityImage) don't
// pull the full next-sanity client into the browser bundle.
const builder = sanityImageURL({
    projectId: appConfig.SANITY_PROJECT_ID,
    dataset: appConfig.SANITY_DATASET
});

/** @param {any} source @param {any} [defaultImage] @param {number | null} [height] @param {number | null} [width] @returns {string | null} */
export function SanityImageURL(source = null, defaultImage = null, height = null, width = null) {
    if (!source) {
        return defaultImage;
    }
    const image = builder.image(source);
    if (height) {
        image.height(height);
    }
    if (width) {
        image.width(width);
    }
    return image.url();
}

/**
 * Build a fixed-aspect Sanity image URL. Sanity's image builder automatically
 * honors crop and hotspot metadata when both dimensions and `fit("crop")` are
 * supplied, while falling back to a centered crop for older images.
 *
 * @param {any} source
 * @param {number} width
 * @param {number} height
 * @returns {string | null}
 */
export function SanityCroppedImageURL(source, width, height) {
    if (!source) {
        return null;
    }

    return builder
        .image(source)
        .width(width)
        .height(height)
        .fit("crop")
        .auto("format")
        .quality(85)
        .url();
}

/**
 * Build an optimized Sanity image URL without forcing a second aspect-ratio
 * crop. This preserves the crop chosen in Studio and lets responsive layouts
 * decide how much of the image to reveal.
 *
 * @param {any} source
 * @param {number} width
 * @returns {string | null}
 */
export function SanitySizedImageURL(source, width) {
    if (!source) {
        return null;
    }

    return builder
        .image(source)
        .width(width)
        .auto("format")
        .quality(85)
        .url();
}
